export default __webpack_public_path__ + "static/media/Semcasting_Archer_RGB_Blk.61248a09.png";